export type TestimonialsType = {
  quote: string;
  user: {
      photoURL: string;
      brandLogoURL: string;
      firstname: string;
      lastname: string;
      title: string;
  };
}[]

export const testimonials: TestimonialsType = [
  {
    quote: 'From the ease and convenience of booking, to the platform, communication, incredible designers and final product, it\'s all AMAZING! I really haven\'t seen better in the staging realm.',
    user: {
      photoURL: '/images/testimonials/dante-burl.png',
      brandLogoURL: '/images/testimonials/compass-icon.jpg',
      firstname: 'Dante',
      lastname: 'Burl',
      title: 'Compass Agent',
    },
  },
  {
    quote: 'We did everything right with this one: listing preparation, staging, and top-tier marketing. We received multiple offers within 36 hours.',
    user: {
      photoURL: '/images/testimonials/connor-cole.png',
      brandLogoURL: '/images/testimonials/agency-logo.png',
      firstname: 'Connor',
      lastname: 'Cole',
      title: 'The Agency',
    },
  },
  {
    quote: 'Guest House Staging staged a condo for me and it sold in less than a week for above asking price. The whole team was accommodating and responsive. I would work with them again in a heartbeat.',
    user: {
      photoURL: '/images/testimonials/carrie-mikel.jpeg',
      brandLogoURL: '/images/testimonials/bhhs-logo.png',
      firstname: 'Carrie',
      lastname: 'Mickel',
      title: 'Berkshire Hathaway',
    },
  },
  {
    quote: 'Guest House is truly a valued partner in our listing experience. We appreciate the professionalism that they bring to the table and stylistically their staging materials elevate value.',
    user: {
      photoURL: '/images/testimonials/catherine-burgess.jpeg',
      brandLogoURL: '/images/testimonials/compass-icon.jpg',
      firstname: 'Catherine',
      lastname: 'Burgess',
      title: 'Compass Agent',
    },
  },
  // {
  //   quote: 'Guest House has been more than a game changer in my business, it is the disruptor I need to get the job done. Simply amazing!',
  //   user: {
  //     photoURL: '/images/testimonials/guy-nahmiach.jpeg',
  //     brandLogoURL: '/images/testimonials/kw-logo.png',
  //     firstname: 'Guy',
  //     lastname: 'Nahmiach',
  //     title: 'Keller Williams',
  //   },
  // },
];

export const denverTestimonials: TestimonialsType = [
  {
    quote: 'Through the whole process, Guest House was awesome! Great communicators, fabulous design (that got tons of compliments), and an easy quote and billing process. Use them!',
    user: {
      photoURL: '/images/testimonials/grace-koch.png',
      brandLogoURL: '/images/testimonials/evelo-logo.png',
      firstname: 'Grace',
      lastname: 'Koch',
      title: 'Leasing Manager',
    },
  },
  {
    quote: 'From the ease and convenience of booking, to the platform, communication, incredible designers and final product, it\'s all AMAZING! I really haven\'t seen better in the staging realm.',
    user: {
      photoURL: '/images/testimonials/dante-burl.png',
      brandLogoURL: '/images/testimonials/compass-icon.jpg',
      firstname: 'Dante',
      lastname: 'Burl',
      title: 'Compass Agent',
    },
  },
  {
    quote: 'Guest House Staging staged a condo for me and it sold in less than a week for above asking price. The whole team was accommodating and responsive. I would work with them again in a heartbeat.',
    user: {
      photoURL: '/images/testimonials/carrie-mikel.jpeg',
      brandLogoURL: '/images/testimonials/bhhs-logo.png',
      firstname: 'Carrie',
      lastname: 'Mickel',
      title: 'Berkshire Hathaway',
    },
  },
  {
    quote: 'Guest House has been more than a game changer in my business, it is the disruptor I need to get the job done. Simply amazing!',
    user: {
      photoURL: '/images/testimonials/guy-nahmiach.jpeg',
      brandLogoURL: '/images/testimonials/kw-logo.png',
      firstname: 'Guy',
      lastname: 'Nahmiach',
      title: 'Keller Williams',
    },
  },
];
